export enum WeaveStructureWidth {
  SINGLE_WIDTH = 'SINGLE_WIDTH',
  DOUBLE_WIDTH = 'DOUBLE_WIDTH'
}
